/**
 * Module NEUTRE « map-embed » — KEEP IN SYNC avec
 * inventozen-frontpublic/src/cms-puck/map-embed.ts
 */
export type MapAspect = "16/9" | "4/3" | "1/1" | "tall";

export const MAP_ASPECT_CLASS: Record<MapAspect, string> = {
  "16/9": "aspect-video",
  "4/3": "aspect-[4/3]",
  "1/1": "aspect-square",
  tall: "aspect-[3/4]",
};

export function normalizeMapAspect(value: unknown): MapAspect {
  const v = String(value ?? "");
  if (v === "4/3" || v === "1/1" || v === "tall") return v;
  return "16/9";
}

/** Normalise une URL d'embed (iframe src) — chaîne vide si invalide. */
export function normalizeMapEmbedUrl(value: unknown): string {
  const url = String(value ?? "").trim();
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return "";
}
